import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';

export default function ComponentContainer({
  children,
  className,
  fill = false
}) {
  return (
    <section
      className={cn(
        'h-full w-full overflow-y-scroll flex flex-col gap-4',
        fill ? 'bg-white p-4' : '',
        className
      )}
    >
      {children}
    </section>
  );
}

ComponentContainer.propTypes = {
  children: propTypes.node.isRequired,
  className: propTypes.string,
  fill: propTypes.bool
};
